import { Trans } from "react-i18next";
import { galleryPosts } from "../../../constants/galleryPosts";
import GalleryCard from "../../Cards/GalleryCard/GalleryCard";
import { CmsGalleryImage } from "../../../types/cms.types";

type GallerySectionProps = {
    styles: Record<string, string>;
    cmsImages?: CmsGalleryImage[]; // Published CMS photos; built-in samples are the fallback
};

const GallerySection = ({ styles, cmsImages }: GallerySectionProps) => {
    // Published CMS photos replace the built-in samples
    const validCmsImages = cmsImages?.filter((image) => image.url) ?? [];
    const items = validCmsImages.length
        ? validCmsImages.map((image) => ({ key: image._key, image: image.url as string }))
        : galleryPosts.map((post, index) => ({ key: `${post.alt}-${index}`, image: post.image }));

    return (
        <div className={styles.Gallery}>
            <div className={styles.GalleryTitle}>
                <p>
                    <Trans i18nKey="home.gallery.title" components={{ 1: <span /> }} />
                </p>
            </div>
            <div className={styles.GalleryContent}>
                {items.map((item) => (
                    <GalleryCard
                        imgSrc={item.image}
                        className={styles.GalleryCard}
                        key={item.key}
                    />
                ))}
            </div>
        </div>
    );
};

export default GallerySection;
